/**
 *
 * @param {string} label Topic code to be searched for
 * @param {Array <Object>} topicOptions All of topic options with codes and labels
 * @param {Array <string>} value Existing topic codes
 * @returns
 */
export function isTopicIncluded(label, topicOptions, value) {
  const correctTopic = topicOptions.find((topic) => topic.label === label);

  if (correctTopic === undefined) return false;

  const code = correctTopic.value;

  return value.includes(code);
}
